<template>
    <IndexTable
        ref="indexTable"
        :action="projectsStore.index"
        :display-actions="false"
        :columns="defaultTableColumns"
        :default-items-per-page="20"
        :bid-status="statusFilter"
        default-status-filter="active"
        :display-status-filter="false"
        :display-settings="displaySettings"
        :display-settings-mobile="displaySettingsMobile"
        :includes="include"
        :items="projects"
        :params="params"
        paginated
        :paginator="paginator"
        resource="project"
        title="Projects"
        @click="handleShow"
        @response="handleResponse"
    />
</template>

<script setup lang="ts">

  import {ref, computed, toRefs} from "vue";
  import type {Ref} from "vue";
  import {useRouter} from "vue-router";

  import type {APIResponse} from '@/api/Api';

  import IndexTable, {type PaginatorType} from "@/components/IndexTable.vue";
  import {storeToRefs} from "pinia";
  import {useProjectsStore} from "@/stores/ProjectsStore";

  const {projects, projectsLinks, projectsMeta} = storeToRefs(useProjectsStore());
  const projectsStore = useProjectsStore();
  const router = useRouter();
  const include = <any>[];
  const defaultTableColumns = [
    // {
    //   field: 'id',
    //   label: 'ID',
    //   width: 40,
    //   numeric: true,
    // },
    {
      field: 'name',
      label: 'Name',
      component: 'ProjectNameColumn',
      sortable: true,
    },
    {
      field: 'city',
      label: 'City',
      sortable: true,
    },
    {
      field: 'state',
      label: 'State',
      sortable: true,
      visible: false,
    },
    {
      field: 'location',
      label: 'Location',
      sortable: true,
    },
    {
      field: 'sub_bid_due',
      label: 'Bid Due',
      sortable: true,
      sortField: 'sub_bid_date,sub_bid_time',
    },
    {
      field: 'site_meeting_at',
      label: 'Site Meeting Date',
      sortable: true,
      sortField: 'site_meeting_date,site_meeting_time',
      visible: false,
    },
    {
      field: 'rfi_due_at',
      label: 'RFI Due',
      sortable: true,
      sortField: 'rfi_due_date,rfi_due_time',
      visible: false,
    },
    {
      field: 'confirmed',
      label: 'Response',
      component: 'ResponseConfirmedColumn',
    },
    {
      field: 'invited',
      label: 'Open/Invited',
      component: 'ProjectInvitedColumn',
    },
  ];

  let paginator: Ref<PaginatorType> = ref<PaginatorType>({
    total: 0,
    count: 0,
    current_page: 1,
    per_page: 20,
    total_pages: 0,
  });

  const props = withDefaults(defineProps<{
    statusFilter?: 'current' | 'past' | null,
    displaySettings?: boolean,
    displaySettingsMobile?: boolean,
  }>(), {
    statusFilter: 'current',
    displaySettings: true,
    displaySettingsMobile: true,
  });
  const {
    statusFilter,
    displaySettings,
    displaySettingsMobile,
  } = toRefs(props);

  const indexTable = ref<InstanceType<typeof IndexTable> | null>(null);

  defineExpose({
    openSettings: () => indexTable.value?.openSettings(),
  });

  const params = ref({
    sort: [
      `${statusFilter.value === 'past' ? '-' : ''}sub_bid_date`,
      `${statusFilter.value === 'past' ? '-' : ''}sub_bid_time`,
    ],
  });

  const projectStatus = computed<string>(() => {
    return statusFilter.value === 'past' ? '/past' : '';
  });
  function handleResponse(response: APIResponse) {
    if (projectsMeta.value?.pagination) {
      paginator.value = projectsMeta.value.pagination;
    }
    else {
      paginator.value = {
        current_page: 1,
        count: projects.value?.length || 0,
        per_page: projects.value?.length || 10,
        total: projects.value?.length || 0,
        total_pages: projects.value?.length ? 1 : 0,
      };
    }
  }

  function handleShow(item: any) {
    router.push({
      name: `projects${projectStatus.value}/show`,
      params: { projectId: item.id },
    });
  }

</script>

<style scoped>

</style>
